function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPipelines(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M3.43 23.93c0-3.45.01-6.9-.01-10.36 0-1.07.49-1.79 1.39-2.31 2.14-1.23 4.26-2.49 6.4-3.73 2.22-1.29 4.45-2.57 6.67-3.85 1.51-.87 3.04-1.72 4.52-2.64.99-.61 1.92-.58 2.89-.02 3.34 1.94 6.68 3.88 10.01 5.82 2.61 1.52 5.22 3.04 7.83 4.57.84.49 1.22 1.28 1.22 2.23v20.61c0 .99-.45 1.76-1.29 2.25-3.19 1.89-6.4 3.75-9.61 5.62-2.74 1.6-5.49 3.17-8.23 4.78-1.14.67-2.15.38-3.2-.26-2.65-1.59-5.33-3.11-8-4.67-2.6-1.51-5.19-3.02-7.78-4.54-.72-.42-1.45-.84-2.12-1.34-.52-.39-.7-1-.7-1.65.02-3.5.01-7 .01-10.51zm21.95 2.22h9.14c.71 0 .94-.23.94-.93v-2.53c0-.67-.25-.93-.9-.94H16.17c-.61 0-.89.28-.9.9-.01.83 0 1.65 0 2.48 0 .81.21 1.02 1.01 1.02h9.1zm-2.91-7.95h9.29c.6 0 .84-.22.85-.81.01-.89.02-1.78 0-2.68-.01-.56-.33-.87-.89-.87H13.29c-.6 0-.86.27-.87.86-.01.87 0 1.75 0 2.63 0 .69.17.87.86.87 3.07.01 6.13 0 9.19 0zm.02 15.85h9.14c.71 0 .98-.26.99-.96.01-.77 0-1.55 0-2.32 0-.86-.22-1.07-1.07-1.07H13.27c-.63 0-.84.22-.84.85v2.57c0 .71.22.93.92.93h9.14z",
    style: {
      fill: "#d0e0f3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.38 26.15h-9.09c-.8 0-1.01-.21-1.01-1.02 0-.83-.01-1.65 0-2.48.01-.62.29-.9.9-.9h18.39c.65 0 .9.27.9.94v2.53c0 .7-.23.93-.94.93h-9.15zm-2.91-7.95h-9.19c-.68 0-.85-.18-.86-.87V14.7c0-.59.27-.86.87-.86h18.43c.56 0 .88.31.89.87.02.89.02 1.78 0 2.68-.01.59-.25.81-.85.81-3.1.01-6.19 0-9.29 0zm.02 15.85h-9.14c-.71 0-.92-.22-.92-.93v-2.57c0-.63.21-.85.84-.85h18.28c.85 0 1.07.22 1.07 1.07 0 .77.01 1.55 0 2.32-.01.7-.28.96-.99.96h-9.14z",
    style: {
      fill: "#4678bc"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPipelines);
export default __webpack_public_path__ + "static/media/pipelines.1f1e45d214d2b0d8db7e10f54f6bd59d.svg";
export { ForwardRef as ReactComponent };